import PropTypes from 'prop-types';
import { GECKO_CONSTS } from '../constants';

export const GeckoTableCellModel = {
  key: PropTypes.string,
  type: PropTypes.oneOf([
    GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    GECKO_CONSTS.TABLE_CELL_TYPE_CURRENCY,
    GECKO_CONSTS.TABLE_CELL_TYPE_DATE,
    GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
    GECKO_CONSTS.TABLE_CELL_TYPE_NAME,
    GECKO_CONSTS.TABLE_CELL_TYPE_STATUS,
  ]),
  name: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  class: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  render: PropTypes.func,
  renderComponent: PropTypes.func,
  handler: PropTypes.func,
  width: PropTypes.string,
  sortable: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export const GeckoTableCellsModel = PropTypes.arrayOf(
  PropTypes.shape(GeckoTableCellModel)
);
